import next from "../../assets/images/next.svg";
import prev from "../../assets/images/prev.svg";
import volumn from "../../assets/images/volume.svg";
import fulscreen from "../../assets/images/fullscreen.svg";
import play from "../../assets/images/play.svg";
import pause from "../../assets/images/pause.svg";
import menu from "../../assets/images/menu.svg";
import menumixer from "../../assets/images/menumixer.svg";
import menumixerhovered from "../../assets/images/menumixerhovered.svg";
import menuscenes from "../../assets/images/menuscenes.svg";
import menusceneshovered from "../../assets/images/menusceneshovered.svg";
import menutool from "../../assets/images/menutool.svg";
import menuyoutube from "../../assets/images/menuyoutube.svg";
import menuyoutubehovered from "../../assets/images/menuyoutubehovered.svg";
import menutimer from "../../assets/images/menutimer.svg";
import menutimerhovered from "../../assets/images/menutimerhovered.svg";
import menunotes from "../../assets/images/menunotes.svg";
import menunoteshovered from "../../assets/images/menunoteshovered.svg";
import menutemplates from "../../assets/images/menutemplates.svg";
import menutemplateshovered from "../../assets/images/menutemplateshovered.svg";
import customplaylist from "../../assets/images/customplaylist.svg";
import spotify from "../../assets/images/spotify.svg";
import riverIcon from "../../assets/images/river.svg";
import birdIcon from "../../assets/images/bird.svg";
import brownIcon from "../../assets/images/brown.svg";
import premium from "../../assets/images/premiumIcon.svg";
import profile from "../../assets/images/profile.svg";
import setting from "../../assets/images/setting.svg";
import contact from "../../assets/images/message.svg";
import pricing from "../../assets/images/pricing.svg";
import info from "../../assets/images/info.svg";
import resize from "../../assets/images/resize.svg";
import cityTraffic from "../../assets/images/citytraffic.svg";
import cityRain from "../../assets/images/cityrain.svg";

export const Icons = {
  next,
  prev,
  volumn,
  fulscreen,
  play,
  pause,
  menu,
  menumixer,
  menumixerhovered,
  menuscenes,
  menusceneshovered,
  menutool,
  menuyoutube,
  menuyoutubehovered,
  menutimer,
  menutimerhovered,
  menunotes,
  menunoteshovered,
  menutemplates,
  menutemplateshovered,
  customplaylist,
  spotify,
  riverIcon,
  birdIcon,
  brownIcon,
  premium,
  profile,
  setting,
  contact,
  pricing,
  info,
  resize,
  cityTraffic,
  cityRain,
};
